import { getBaseQuery, getBaseUrl } from '../../Utils';
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
// import { HomeWorkspaceTiles, AddOneWorkspace } from '../../Types/HomePageInterface'

function convertToFormData<T extends Record<string, any>>(data: T): FormData {
  const formData = new FormData();
  
  Object.entries(data).forEach(([key, value]) => {
    if (Array.isArray(value)) {
      value.forEach((item) => {
        if (typeof item === 'object' && item !== null) {
          // Stringify objects before appending
          formData.append(`${key}[]`, JSON.stringify(item));
        } else {
          formData.append(`${key}[]`, String(item));
        }
      });
    } else if (typeof value === 'object' && value !== null) {
      // Stringify single objects
      formData.append(key, JSON.stringify(value));
    } else {
      formData.append(key, String(value));
    }
  });
  return formData;
}


const baseUrl = `${getBaseUrl()}api/v3/Notifications`;

export const UserNotifications = createApi({
    reducerPath:'Notifications',
    baseQuery: fetchBaseQuery({baseUrl:baseUrl}),
    endpoints: (builder) => ({
        GetMyNotifications: builder.mutation<any, { [key: string]: any }>({
            query: (params) => ({
              url: '/my',
              method: 'GET',
              params,
            }),
            transformResponse: (response: any) => {
              return response;
            },
          }),
    })
})

export const {
    useGetMyNotificationsMutation,
} = UserNotifications;